import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

//styles
import './style.scss';

//antd component
import { Button } from 'antd';

import { useTranslation} from "react-i18next";

//assets
import CustomIcons from 'components/CustomIcons';

function NoAbsence({
  title,
  content,
  // actions
  newAction,
  filterAction,
  // default
  children,
  className,
  ...rest
}) {
  const childClassName = classNames('no-absence-screen', className);
  const { t } = useTranslation();

  return (
    <>
      {title && (
        <div className={childClassName} {...rest}>
          <CustomIcons className="no-absence-screen__icon" type="no-absence" />
          <div className="no-absence-screen__content">
            <h3 className="content-title">{title}</h3>
            {(content || children) && (
              <div
                className="content-text"
                dangerouslySetInnerHTML={{ __html: content || children }}
              />
            )}
          </div>
          <div className="no-absence-screen__actions">
            {newAction !== undefined && (
              <Button type="link" onClick={newAction} className="link-request">
                {t('absences.newRequest')}
              </Button>
            )}
            {filterAction !== undefined && (
              <Button type="link" onClick={filterAction} className="link-request">
                {t('absences.consultAbsences')}
              </Button>
            )}
          </div>
        </div>
      )}
    </>
  );
}

NoAbsence.defaultProps = {};
NoAbsence.propTypes = {
  title: PropTypes.string.isRequired,
  newAction: PropTypes.func,
  filterAction: PropTypes.func,
};

export default memo(NoAbsence);
